/**
 * Admin-authored HTML as the resident actually reads it — tags dropped, entities decoded
 * (`&amp;` → `&`), whitespace collapsed. Used for list previews and for matching search terms
 * against body copy, both of which have to work off the rendered text rather than the markup.
 *
 * `text/html` parses into an inert document: no script runs and no resource is fetched.
 */
export function toMessageSnippet(html: string | undefined): string {
  if (!html) return '';

  const doc = new DOMParser().parseFromString(html, 'text/html');
  doc.querySelectorAll('script, style').forEach((element) => element.remove());

  // `\s` covers the non-breaking spaces Quill and email HTML are full of.
  return (doc.body.textContent ?? '').replace(/\s+/g, ' ').trim();
}
